function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M78.3379 32H49.6613C39.9229 32 32 39.9232 32 49.6617V78.3383C32 88.0771 39.9229 96 49.6613 96H78.3379C88.0771 96 96 88.0768 96 78.3383V49.6617C96.0004 39.9232 88.0771 32 78.3379 32ZM90.322 78.3383C90.322 84.9461 84.9461 90.3216 78.3383 90.3216H49.6613C43.0539 90.322 37.6784 84.9461 37.6784 78.3383V49.6617C37.6784 43.0543 43.0539 37.6784 49.6613 37.6784H78.3379C84.9457 37.6784 90.3216 43.0543 90.3216 49.6617L90.322 78.3383Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.9999 47.5095C54.9065 47.5095 47.5087 54.9073 47.5087 64.0006C47.5087 73.0936 54.9065 80.4911 63.9999 80.4911C73.0932 80.4911 80.491 73.0936 80.491 64.0006C80.491 54.9073 73.0932 47.5095 63.9999 47.5095ZM63.9999 74.8123C58.0379 74.8123 53.1871 69.9622 53.1871 64.0003C53.1871 58.038 58.0376 53.1875 63.9999 53.1875C69.9622 53.1875 74.8127 58.038 74.8127 64.0003C74.8127 69.9622 69.9618 74.8123 63.9999 74.8123Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.1831 42.6946C80.0891 42.6946 79.0144 43.1375 78.2418 43.9136C77.4653 44.6858 77.019 45.7609 77.019 46.8587C77.019 47.9532 77.4657 49.0279 78.2418 49.8039C79.014 50.5762 80.0891 51.0229 81.1831 51.0229C82.281 51.0229 83.3523 50.5762 84.1283 49.8039C84.9044 49.0279 85.3473 47.9528 85.3473 46.8587C85.3473 45.7609 84.9044 44.6858 84.1283 43.9136C83.3561 43.1375 82.281 42.6946 81.1831 42.6946Z"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "33 33 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.1b7bfd41.svg";
export { ForwardRef as ReactComponent };